import SafeImage from '@ui/SafeImage';
import { prefix } from '@util/imagePrefix';
import { isMobile } from '@util/index';
import UpgradeNowTrigger from 'app/boot-trade-in-program/_components/UpgradeNowTrigger';
import Image from 'next/image';

export const BootTradeInSection = () => {
  return (
    <div className="relative flex h-[40rem] w-full overflow-hidden rounded-[2rem] bg-[#F6F6F6] sm:mx-auto sm:h-[30rem] sm:max-w-[150rem]">
      <div className="flex h-full flex-col items-start justify-end gap-y-8 pb-16 pl-12 sm:justify-center sm:pb-0">
        <div className="flex flex-col items-start gap-y-2">
          <span className="text-[1.8rem] font-medium text-zinc-700">
            Boot Trade-In Program
          </span>

          <span className="w-[40rem] text-[2.7rem] font-bold text-black">
            Trade in Your Used Boots, for New Boots!
          </span>
        </div>

        <UpgradeNowTrigger title="Trade Now!" />
      </div>

      <Image
        src={`${prefix}/assets/homepage-trage-in-boot_1920x2560.png`}
        alt="Trade In Boots"
        className="absolute -right-2 h-[20rem] w-auto sm:h-full"
        height={400}
        width={400}
      />
    </div>
  );
};
